import { FC } from "react";
import { IconButton, styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { useNavigate } from "react-router-dom";
import authStore from "@/stores/authStore";
import filtersStore from "@/stores/filtersStore";

interface ISidebarBtnProps {
    isActive: boolean;
    buttonClass: string;
    navigatePath: string;
    tooltipName: string;
    showMenu?: void | null | Function;
}

const SidebarRootBtn: FC<ISidebarBtnProps> = (props: ISidebarBtnProps): JSX.Element => {
    const { isActive, buttonClass, navigatePath, tooltipName } = props;
    const navigate = useNavigate();
    function navigateAndShow(path: string) {
        filtersStore.setEmployeeFilterData(null);
        filtersStore.setEmployeeWalletFilterData(null);
        filtersStore.setEmployeeOrderFilterData(null);
        filtersStore.setEmployeeDocFilterData(null);
        filtersStore.setDigitalWalletsFilterData(null);
        filtersStore.setDigitalWalletsHiddenFilter(null);
        filtersStore.setDigitalWalletManagmentFilterData(null);
        filtersStore.setDigitalWalletManagmentHiddenFilter(null);
        filtersStore.setAccountingFilterData(null);
        filtersStore.setAccountingHiddenFilter(null);
        filtersStore.setOrdersFilterData(null);
        filtersStore.setOrdersHiddenFilter(null);
        filtersStore.setFormsFilterData(null);
        filtersStore.setUsersFilterData(null);
        filtersStore.setProfilesFilterData(null);
        filtersStore.setInterfacesFilterData(null);
        navigate(path);
        showSideBar();
    }

    const StyledButton = styled(IconButton)(
        () => `
          &:hover {
            background-color: transparent;
          }
        `
    );
    function showSideBar() {
        if (props.showMenu) {
            props.showMenu(true);
        }
    }
    const SidebarTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#7E8EC4",
            fontSize: 12,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#7E8EC4",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: 700,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "7px 10px",
            left: authStore.isRtl ? "7px" : "-7px",
        },
    }));

    return (
        <SidebarTooltip title={tooltipName} placement="right">
            <StyledButton
                onClick={() => navigateAndShow(navigatePath)}
                className={"customSideBtn " + (isActive ? "activeSideBtn" : "")}
                sx={{ marginBottom: "10px", hover: "none" }}
            >
                <div className="button-radius-component">
                    <div className="top-first">
                        <div className="top-second"></div>
                    </div>
                    <div className="bottom-first">
                        <div className="bottom-second"></div>
                    </div>
                </div>
                <i className={"icon-f " + buttonClass + " fs-26 customSideBtnIcon"} />
            </StyledButton>
        </SidebarTooltip>
    );
};

export default SidebarRootBtn;
